import gql from 'graphql-tag';
import {
  BillingMethodIdentifyShopper,
  BillingMethodChallengeShopper,
} from '../schemas/rql';
import { graphql } from 'react-apollo';
import { myShopBillingMethods } from './billing_method_operations';

const BILLING_METHOD_IDENTIFY_SHOPPER = gql`
  mutation BillingMethodIdentifyShopper($input: Input_core_apimessages_BillingMethodIdentifyShopperRequest) {
    billingMethodIdentifyShopper(input: $input) {
      creditCard {
        id
      }
      billingMethodUuid
      adyenPaymentResult {
        paymentStatus
        challengeToken
        paymentData
      }
      me {
        ...myShopBillingMethods
      }

    }
  }
  ${myShopBillingMethods}
`;

const BILLING_METHOD_CHALLENGE_SHOPPER = gql`
  mutation BillingMethodChallengeShopper($input: Input_core_apimessages_BillingMethodChallengeShopperRequest) {
    billingMethodChallengeShopper(input: $input) {
      creditCard {
        id
      }
      billingMethodUuid
      adyenPaymentResult {
        paymentStatus
        paymentData
      }
      me {
        ...myShopBillingMethods
      }
    }
  }
  ${myShopBillingMethods}
`;

export const connectBillingMethodIdentifyShopper = graphql<{}, BillingMethodIdentifyShopper.Mutation, BillingMethodIdentifyShopper.Variables>(
  BILLING_METHOD_IDENTIFY_SHOPPER,
  {
    name: 'identifyShopper',
  },
);

export const connectBillingMethodChallengeShopper = graphql<{}, BillingMethodChallengeShopper.Mutation, BillingMethodChallengeShopper.Variables>(
  BILLING_METHOD_CHALLENGE_SHOPPER,
  {
    name: 'challengeShopper',
  },
);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/threeds2_billing_operations.ts